<script>
  import { onMount } from 'svelte';

  onMount(() => {
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100vh';

    return () => {
      document.body.style.overflow = 'initial';
      document.body.style.height = 'auto';
    };
  });
</script>
